import * as React from 'react';

import SearchCardsPlaceHolder from 'bundles/coursera-ui/components/search/SearchCardsPlaceHolder';

type Props = {
  searching: boolean;
  numberOfResults: any;
};

const SearchPlaceHolderWrapper: React.LegacyFunctionComponentWithChildren<Props> = ({
  searching,
  numberOfResults,
  children,
}) => {
  return searching ? <SearchCardsPlaceHolder count={numberOfResults} /> : <div>{children}</div>;
};

export default SearchPlaceHolderWrapper;
